import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/comicGuide";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2 shrink-0">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-mental-health-line text-xl"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl ${scrolled ? "text-foreground-900" : "text-background-50"}`}
          >
            66漫画网
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`px-3 py-2 text-sm rounded-md transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-50/90 hover:text-background-50 hover:bg-white/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="#guide"
          className={`hidden md:inline-flex whitespace-nowrap items-center gap-1 rounded-md px-4 py-2 text-sm font-medium transition-colors ${
            scrolled
              ? "bg-primary-500 text-background-50 hover:bg-primary-600"
              : "bg-background-50/15 text-background-50 border border-background-50/40 hover:bg-background-50/25"
          }`}
        >
          <i className="ri-settings-3-line text-base"></i>
          阅读设置指南
        </a>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden flex h-10 w-10 items-center justify-center rounded-md ${
            scrolled
              ? "text-foreground-900 hover:bg-background-100"
              : "text-background-50 hover:bg-white/10"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50/95 backdrop-blur px-4 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#guide"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50 hover:bg-primary-600"
            >
              <i className="ri-settings-3-line text-base"></i>
              阅读设置指南
            </a>
          </div>
        </div>
      )}
    </header>
  );
}